import svgPanZoom from 'svg-pan-zoom';

export default () => ({
    data: () => ({
        spz: null
    }),
    mounted() {
        // this.spz = svgPanZoom(this.$refs.diagramRoot, {
        //     viewportSelector: this.$refs.viewPort,
        //     center: true,
        //     fit:true,
        //     contain:true,
        //     preventMouseEventsDefault: this.preventMouseEventsDefault,
        //     beforePan: this.beforePan,
        //     maxZoom:0.7,
        //     minZoom:0.7,
        //     beforeZoom: () => this.zoomEnabled,
        // });
        // const point = {
        //     x:0,
        //     y:0
        // }
        // this.spz.zoomAtPoint(0.7,point)
    },
    beforeDestroy() {
        if (this.spz) {
            this.spz.destroy();
        }
    },
    methods: {
        enableDblClickZoom() {
            if (this.spz) return this.spz.enableDblClickZoom();
        },
        disableDblClickZoom() {
            if (this.spz) return this.spz.disableDblClickZoom();
        },
        isDblClickZoomEnabled() {
            if (this.spz) return this.spz.isDblClickZoomEnabled();
        },
        enableMouseWheelZoom() {
            if (this.spz) return this.spz.enableMouseWheelZoom();
        },
        disableMouseWheelZoom() {
            if (this.spz) return this.spz.disableMouseWheelZoom();
        },
        isMouseWheelZoomEnabled() {
            if (this.spz) return this.spz.isMouseWheelZoomEnabled();
        },
        resetZoom() {
            if (this.spz) return this.spz.resetZoom();
        },
        updateBBox() {
            if (this.spz) return this.spz.updateBBox();
        },
        fit() {
            if (this.spz) return this.spz.fit();
        },
        contain() {
            if (this.spz) return this.spz.contain();
        },
        center() {
            if (this.spz) return this.spz.center();
        },
    },
});
